import React, { useMemo } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { WEB_URL } from "../../api/URLs";
import { GTM_EVENTS, S3_BUCKET } from "../../constants";
import { MixPanelTrackedLink, ProgressBar } from "../../components";
import CampaignCoverSkeleton from "./skeletons/CampaignCoverSkeleton";
import { useNavigate } from "react-router-dom";

export default function () {

    const navigate = useNavigate();
    const campaignDetails = useSelector(state => state.fundraiser_page.campaign_details);

    const campaignCover = useMemo(
        () => {
            let defaultCover = null;
            let campaignImage = null;

            if (isMobile) {
                defaultCover = require(`../../assets/images/home-slide-mobile.jpg`);
                campaignImage = campaignDetails?.campaign_image_responsive;
            }

            else {
                defaultCover = require(`../../assets/images/home-slide1.jpg`);
                campaignImage = campaignDetails?.campaign_image;
            }

            return campaignImage ? S3_BUCKET + campaignImage : defaultCover;
        },
        [campaignDetails]
    );

    const goalAchievedPercentage = useMemo(
        () => {
            return (campaignDetails?.int_total_fund_raised / campaignDetails?.int_fundraising_goal) * 100
        },
        [campaignDetails]
    );

    return campaignDetails ? <Box className="CampaignCoverBox" sx={{ backgroundImage: `url(${campaignCover})` }}>
        {campaignDetails?.show_overlay_on_banner ?
            <Box className="Overlay">
            </Box>
            : null
        }
        <Container className="CampaignDetailsContainer">
            <Stack spacing={2} className="CampaignCoverStack">
                <Typography variant="h4" align="center">{campaignDetails?.name}</Typography>
                {campaignDetails?.fundraising_goal && <ProgressBar
                    percentage={goalAchievedPercentage}
                    minValueText={`${campaignDetails?.total_fund_raised} ${campaignDetails?.campaign_goal ? 'Supporting' : 'raised'}`}
                    maxValueText={`${campaignDetails?.fundraising_goal} ${campaignDetails?.campaign_goal ? 'Students' : 'goal'}`}
                    textColor="white"
                    fontSize="large"
                />}
                <Stack className="ButtonsStack">
                    {
                        campaignDetails?.show_start_fundraiser_btn ?
                            <MixPanelTrackedLink type="button" label="Start Fundraising" context="Campaign page" variant="contained"
                                className="StartFundraiserButton"
                                gtmEvent={GTM_EVENTS.START_FUNDRAISER_CLICKED}
                                onClick={() => navigate(WEB_URL.CREATE_FUNDRAISER, {
                                    state: { campaignId: campaignDetails.id }
                                })}>
                                Start Fundraising
                            </MixPanelTrackedLink> :
                            null
                    }

                    {
                        campaignDetails?.allow_direct_donations ?
                            <MixPanelTrackedLink
                                type="button"
                                label="Donate Now"
                                context="Campaign page"
                                variant="contained"
                                color="secondary"
                                className="DonateNowButton"
                                gtmProps={{
                                    fundrasier_name: campaignDetails?.name,
                                    raised_amount: campaignDetails?.total_fund_raised,
                                    number_of_donation: campaignDetails?.count_donations,
                                    goal_amount: campaignDetails?.campaign_goal
                                }}
                                gtmEvent={GTM_EVENTS.DONATE_NOW_CLICKED}
                                href={WEB_URL.CAMPAIGN_CHECKOUT(campaignDetails?.event_id)}
                            >
                                Donate Now
                            </MixPanelTrackedLink> :
                            null
                    }
                </Stack>
            </Stack>
        </Container>
    </Box> : <CampaignCoverSkeleton />
}